import React from 'react';
import { useQuery, useMutation, useApolloClient, ApolloProvider } from '@apollo/client/react';

export { ApolloProvider };

export function ApolloConsumer({ children }) {
    const client = useApolloClient();
    return children(client);
}

// Apollo 3+ freezes query results; callers in this repo mutate data in place.
function cloneData(data) {
    if (!data) return {};
    try {
        return JSON.parse(JSON.stringify(data));
    } catch (e) {
        return data;
    }
}

export function Query({ children, query, variables, fetchPolicy, client, pollInterval, skip, context, ...rest }) {
    const options = { variables, fetchPolicy, pollInterval, skip, context, ...rest };
    if (client) options.client = client;
    const result = useQuery(query, options);
    return children({ ...result, data: cloneData(result.data) });
}

export function Mutation({ children, mutation, variables, onCompleted, onError, refetchQueries, update, client, context, ...rest }) {
    const options = { variables, onCompleted, onError, refetchQueries, update, context, ...rest };
    if (client) options.client = client;
    const [mutate, result] = useMutation(mutation, options);
    return children(mutate, result);
}

export function withApollo(Component) {
    function WithApollo(props) {
        const client = useApolloClient();
        return <Component {...props} client={client} />;
    }
    WithApollo.displayName = `withApollo(${Component.displayName || Component.name || 'Component'})`;
    return WithApollo;
}

export function compose(...funcs) {
    if (funcs.length === 0) return arg => arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b) => (...args) => a(b(...args)));
}
